export default __webpack_public_path__ + "static/poppins-v20-latin-ext-500-fd92e6e2242ab8df6db473764c4e149c.woff2";